<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="操作验证"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="bj-rows">
          <div class="name">手机号码：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="user.phoneNumber"
            disabled
            placeholder="请输入手机号码"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="bj-rows" style="margin-top: 20px">
          <div class="name">验证码：</div>
          <div class="bj-rows">
            <Input
              class="bj-input-h45 bj-hover-input-F85A36"
              v-model="form.code"
              @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
              placeholder="请输入验证码"
              style="width: 150px"
              clearable
            />
            <smsBtn
              ref="smsBtn"
              height="45px"
              shape=""
              @tap="getCodeEvent"
              style="width: 120px; margin-left: 30px"
            ></smsBtn>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Button :loading="loading" @click="onConfirm" class="modal-confirm" style="margin-right: 20px">确定</Button>
      <Button @click="onCancel" class="modal-cancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { smsSend } from "api/user.js";
import { mapMutations, mapState } from "vuex";
import loading from "components/loading.vue";
import smsBtn from "components/smsBtn.vue";
export default {
  name: "autoRenewModal",
  components: {
    loading,
    smsBtn,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        code: "",
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_TOKEN_INFO"]),
    // 取消
    onCancel() {
      this.form = this.$options.data().form;
      this.$refs.smsBtn.reset();
      this.visibility = false;
    },
    // 获取验证码
    getCodeEvent(callback) {
      smsSend()
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 确认
    async onConfirm() {
      if (!this.form.code) {
        this.$Message.warning("请输入验证码！");
        return false;
      }
      this.loading = true;
      this.$emit("confirm", this.form.code, (res) => {
        if (res) {
          this.loading = false;
          this.$refs.smsBtn.reset();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.section{
    padding: 30px 0;
  }
  .bj-rows{
    height: 45px;
    line-height: 45px;
    margin-bottom: 10px;
  }
  .name {
    color: #333333;
    font-size: 16px;
    min-width: 100px;
    text-align: right;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: center;
  }
</style>

